module.exports = __webpack_public_path__ + "img/head-think-anim.c0d82b21.svg";